import React, { useState } from 'react';
import { Button, Layout } from 'antd';
import Sidebar from './Sidebar';
import Header from './Header';
import { UploadOutlined } from '@ant-design/icons';
import { useLocation, useNavigate } from 'react-router-dom';

const { Content } = Layout;

interface MainLayoutProps {
  children: React.ReactNode;
}

const MainLayout: React.FC<MainLayoutProps> = ({ children }) => {
  const location = useLocation();
  const navigate = useNavigate();
  
  return (
    <Layout style={{ minHeight: '100vh' }}>
      <Sidebar />
      <Layout>
        <Header />
        <Content style={{ padding: '24px', backgroundColor: '#e4eef6' }}>
          {children}
        </Content>
        {process.env.REACT_APP_API_URL !== 'https://brigade-api.digiaim.ai/' && (
          ( location.pathname !== "/address-list" &&
              <Button
                type="primary"
                shape="circle"
                icon={<UploadOutlined />}
                hidden={false}
                style={{
                  position: 'fixed',
                  bottom: '24px',
                  right: '24px',
                  display: 'block'
                }}
                onClick={() => navigate('/upload')}
              />
          )
        )}
      </Layout>

    </Layout>
  );
};

export default MainLayout;
